<template>
<div class="chapter">
<div class="inner_page">
<h1 style="text-align:center;">Contents</h1>
<p class="center-1"><a href="#/xhtml/summer">Summer: 1978</a></p>
<p class="center-1"><a href="#/xhtml/chapter01">one</a></p>
<p class="center-1"><a href="#/xhtml/chapter02">two</a></p>
<p class="center-1"><span href="#/xhtml/chapter03" title="Link target outside of Sample">three</span></p>
<p class="center-1"><span href="#/xhtml/chapter04" title="Link target outside of Sample">four</span></p>
<p class="center-1"><span href="#/xhtml/chapter05" title="Link target outside of Sample">five</span></p>
<p class="center-1"><span href="#/xhtml/chapter06" title="Link target outside of Sample">six</span></p>
<p class="center-1"><span href="#/xhtml/chapter07" title="Link target outside of Sample">seven</span></p>
<p class="center-1"><span href="#/xhtml/chapter08" title="Link target outside of Sample">eight</span></p>
<p class="center-1"><span href="#/xhtml/chapter09" title="Link target outside of Sample">nine</span></p>
<p class="center-1"><span href="#/xhtml/chapter10" title="Link target outside of Sample">ten</span></p>
<p class="center-1"><span href="#/xhtml/chapter11" title="Link target outside of Sample">eleven</span></p>
<p class="center-1"><span href="#/xhtml/chapter12" title="Link target outside of Sample">twelve</span></p>
<p class="center-1"><span href="#/xhtml/chapter13" title="Link target outside of Sample">thirteen</span></p>
<p class="center-1"><span href="#/xhtml/chapter14" title="Link target outside of Sample">fourteen</span></p>
<p class="center-1"><span href="#/xhtml/chapter15" title="Link target outside of Sample">fifteen</span></p>
<p class="center-1"><span href="#/xhtml/chapter16" title="Link target outside of Sample">sixteen</span></p>
<p class="center-1"><span href="#/xhtml/chapter17" title="Link target outside of Sample">seventeen</span></p>
<p class="center-1"><span href="#/xhtml/chapter18" title="Link target outside of Sample">eighteen</span></p>
<p class="center-1"><span href="#/xhtml/chapter19" title="Link target outside of Sample">nineteen</span></p>
<p class="center-1" style="margin-top:20px;"><span href="#/xhtml/Preview" title="Link target outside of Sample">Preview: <i>When Last Seen Alive</i></span></p>
<p class="center-1" style="margin-top:20px;"><span href="#/xhtml/acknowledgement" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?069a1552